module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "ch-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Knight’s Cross Winners of the Waffen-SS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Knight’s Cross of the Iron Cross, in its various grades, was the highest German military award for bravery and combat success during the Second World War. The Iron Cross itself dated from 1813, during the Prussian War of Liberation. It was reactivated in 1870 for the Franco-Prussian War, and again in 1914 for the First World War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Knight’s Cross was a new addition to the Iron Cross, added on September 1, 1939. In previous wars, dating back to the eighteenth century, the Pour le Mérite had been the highest Prussian award for bravery. Its French name reflected the prevailing language of German nobility in the era of its creation. An extension of this is that it was an award for officers and aristocrats.While the Iron Cross and the Pour le Mérite were Prussian decorations, they were awarded throughout the German military, and to their allies, during the First World War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Iron Cross was re-activated for issue on the outbreak of the Second World War.The Pour le Mérite was not. In its place, Adolf Hitler decreed the creation of the Knight’s Cross of the Iron Cross.This new medal, with a German name, could be awarded to both officers and enlisted men. It recognized both outstanding bravery and successful command of important operations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The original intention of the German military was to split the Iron Cross awards into four levels. The base was the Iron Cross Second Class, presented for an act of bravery beyond the normal performance of duty. It was the prerequisite for the Iron Cross First Class, which recognized further or more significant bravery. Special clasps were created for both classes, to be presented to men who held the First World War versions of either Iron Cross and won them again in the current war. The Knight’s Cross was to be a much rarer decoration, presented for actions decisive to the war effort. Finally, the Grand Cross of the Iron Cross was intended to be the ultimate medal, only awarded a few times to senior leadership. In the event it was awarded just once, to Hermann Göring following the 1940 Western Campaign.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The prolonged war saw German soldiers, sailors and air crew perform multiple acts of bravery. These acts were recognized through the creation of additional awards, both in and out of the Iron Cross series. To the Knight’s Cross of the Iron Cross was added, for further decisive bravery or leadership, the Oak Leaves, then the Swords, the Diamonds and finally the Golden Oak Leaves with Swords and Diamonds. This last was awarded just once, and its predecessor only twenty-seven times.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many members of the German military performed acts of bravery that would have qualified them to win the Iron Cross First Class on multiple occasions.This became recognized through the creation of the German Cross in Gold. The Iron Cross First Class was a prerequisite, but the German Cross in Gold was kept separate from the Knight’s Cross and was awarded approximately five times as often. It was not a prerequisite for the Knight’s Cross, and many Knight’s Cross winners never received the German Cross in Gold, while others earned it after being awarded their Knight’s Cross.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On other occasions, acts of overwhelming bravery were performed, but which were of local, more than strategic importance. For this, the recognition came via entry in the Honor Roll of the German Army, Navy, or Air Force.Waffen-SS men were included in the Honor Roll of the German Army, and men entered on the Roll received a special clasp to wear on the ribbon of the Iron Cross Second Class.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The final high award that was discussed in the context of the others was the Close Combat Clasp in Gold.The Close Combat Clasp was created during 1942 to recognize the prolonged time that infantrymen and their supporting services spent on the front lines. While a limited number of “days” could be counted for extended continuous front-line service, the intention was to award the Close Combat Clasp for actual days of hand-to-hand combat with the enemy, as recorded in the recipient’s paybook by his superiors.The basic Bronze grade was for fifteen days, while the Silver was for thirty. The Close Combat Clasp in Gold was awarded to men who had engaged in fifty or more days of hand-to-hand combat. As a common but unofficial practice, men who earned the Close Combat Clasp in Gold received an automatic award of the German Cross in Gold, and its prerequisite grades of the Iron Cross if they hadn’t yet been awarded these. For men of the Waffen-SS, it was not unusual to see them wearing a combination of Iron Crosses, the German Cross in Gold, the Close Combat Clasp, the Knight’s Cross and sometimes the Honor Roll Clasp. ‘Assault Badges’, which were valued but were less prestigious than any of the above, were also commonly worn by experienced soldiers, along with Wound Badges and a variety of foreign decorations.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Waffen-SS was the military arm of the Nazi Party. It was a branch of the Schützstaffel (SS), the protection squads formed to guard Nazi speakers at political rallies.The Waffen-SS developed from four primary sources.The most important was the political readiness detachments the SS organized in several German cities after the Nazis came to power in early 1933. By 1935 these detachments became organized along military lines as battalions, and eventually regiments, and were then called SS special-purpose troops (SS-VT).Their mission was to maintain order in the event of anti-Nazi revolutionary activity. By 1938, the SS-VT comprised the regiments Deutschland, Germania and Der Führer, along with supporting battalions of specialists such as signalers and combat engineers. This militarized force was tolerated by the German Army because it freed them from having to worry about quelling civil unrest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second source of the Waffen-SS was the SS bodyguard that Adolf Hitler formed after becoming Chancellor of Germany. His Leibstandarte (LAH) developed into an infantry regiment similar to those of the SS-VT. It later expanded into a brigade, and eventually a division.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The SS was in charge of the German concentration camp system. These camps required guards, who were known as Death’s Head formations (SS-TV). Guards were recruited far in excess of the numbers required, so that the SS could have another militarized force under "), _c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _vm._v("its command. The SS-TV also became organized into infantry regiments, though their training remained at a lower level than that of the SS-VT and LAH.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, the SS also became in charge of the German State Police (OP).The Treaty of Versailles limited the German Army to only 100,000 men. The leaders of the army accepted only the most qualified candidates. Other men, only slightly less qualified, were instead channeled into the police forces, so they could maintain paramilitary training and be ready to serve in the army again whenever future expansion occurred. As the SS formed the SS-VT, LAH and SS-TV, police leaders were transferred to serve with them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The German Army and SS understood that if Germany went to war, the excess men of the SS-TV and OP would be formed into divisions for combat.The outbreak of the Second World War led to discussions in the autumn of 1939. The result was that the SS was allowed to control the new SS-Totenkopf and SS-Polizei divisions. By early 1940, SS military units became known by the umbrella term Waffen-SS.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The SS was already authorized to create additional SS-TV regiments on a wartime basis, for occupation duty in lands conquered during wartime. These “wartime reinforcements” were gradually converted into SS infantry regiments. SS cavalry regiments were formed for similar duties, and gradually expanded in number.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The SS actively recruited non-Germans for both political and military service. Initially, it sought Germans from outside Germany and Austria (Volksdeutsche), and from peoples it considered to be of related Germanic stock. The SS hoped to use its recruits as a wedge to introduce Nazi ideology into other countries.As the Second World War progressed, increasing numbers of foreign men, often not German or Germanic, were brought into SS military service on the basis of wartime need.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the original mission of the Waffen-SS was homeland security and maintaining order in occupied territories, it was considered appropriate that its units see front-line service. This would give them combat experience and establish credentials for their other roles. At the front, Waffen-SS units fought under German Army command, though at times they could be commandeered for other services, such as aiding police forces in anti-partisan operations and assisting Einsatzgruppen murder squads. Certain units had these tasks as their primary mission, but the majority of the Waffen-SS fought as combat soldiers, seeing action on every front except North Africa.Through their service, the men of the Waffen-SS qualified for the full variety of German military and police decorations. Showing photos of Waffen-SS men wearing the highest of these decorations is the purpose of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Waffen-SS had limited involvement in the Polish Campaign. LAH saw heavy fighting, especially during the Polish counteroffensive along the Bzura River. Much of the SS-VT served with German Army elements in a mixed Panzer Division. The Germania Regiment served separately, and one of its battalions was mauled by elite Polish troops forcing a passage to Romania and exile. SS-TV and cavalry units were used in murder operations against the Polish population after the occupation. No Knight’s Crosses were earned by the Waffen-SS in these military and police operations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The various parts of the SS-VT were brought together on October 19, 1939 to form the SS-V Division. This was later known as SS-Division Reich, and finally as Das Reich. The Totenkopf and Polizei divisions began to organize around this time.Thus, for the 1940 Western Campaign, the Waffen-SS consisted of three motorized divisions and LAH still at regimental strength.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-10"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the fighting that began on May 10, 1940, LAH and the Der Führer Regiment advanced into the Netherlands. Der Führer distinguished itself by breaking through the Dutch Grebbe Line of defenses in the Grebbe Hills.As Dutch resistance collapsed, LAH and the SS-V Division advanced into Belgium, occupying the strategic area around Antwerp. After further fighting around Dunkirk, they participated in the battle for France which saw the complete German victory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Totenkopf and the SS-Polizei Division fought their first battles during the Western Campaign. Totenkopf fought in Belgium, defending against the British tank attack at Arras. It was then part of the battle for France, ultimately driving to the Spanish border. The SS-Polizei Division was in reserve during the first phase of the campaign. It was then used as an assault division, despite being a horse-drawn infantry unit, in the battle for France. Neither Totenkopf nor the SS-Polizei Division earned Knight’s Crosses during these combats.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_10_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("LAH commander Sepp Dietrich before the war. He won the first Knight’s Cross awarded to a member of the Waffen-SS on July 4, 1940 from a recommendation prepared by German Army Commander-in-Chief Walther von Brauchitsch. It recognized Dietrich’s leadership in Poland and the Western Campaign. Dietrich wears his First World War Panzer Assault Badge next to his Iron Cross First Class from the same war. Behind him, on the right, is Blood Flag standard-bearer Jakob Grimminger.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_11_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Felix Steiner was awarded the Knight’s Cross on August 15, 1940 for his Deutschland Regiment’s role in the Western Campaign. Steiner wears the clasps to both of his First World War Iron Crosses.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_11_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Der Führer Regiment commander Georg Keppler. He was awarded the third Waffen-SS Knight’s Cross on August 22, 1940 for the way his regiment broke through the Dutch Grebbe Line.This considerably hastened the surrender of the Netherlands. Keppler also held both classes of the First World War Iron Cross.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_12_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Ludwig Kepplinger was one of Keppler’s platoon commanders in the 11th Company of Der Führer. With only two other men, he eliminated several Dutch forts. This made the regiment’s advance through the Grebbe Line possible. Kepplinger’s Knight’s Cross was dated September 4, 1940. By that date he had received a field promotion to Untersturmführer for bravery in the face of the enemy. However, he had probably not had the opportunity to update his dress uniform prior to the taking of this formal portrait. Kepplinger had received five bullet wounds the day after his decisive action, and this is reflected in his Wound Badge in Silver, worn under his Iron Cross First Class.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_13_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Fritz Vogt was a noted daredevil in the SS-V Reconnaissance Battalion. Among his platoon’s accomplishments was the capture of an entire French battalion during the clearing of the Scheldt estuary. Vogt was the second of three Waffen-SS September 4, 1940 Knight’s Cross recipients. He received his decoration from SS-V Division Commander Paul Hausser at a ceremony held in the occupied Netherlands.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_14_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("The third September 4, 1940 Knight’s Cross winner was Fritz Witt, commander of the 1st Battalion of the Deutschland Regiment. He had led his men in close combat against a British tank attack on May 27, 1940. Later, towards the close of the campaign, Witt’s battalion captured almost 20,000 French prisoners. In this photo, Witt wears Deutschland’s “SS 1” collar patch that was officially discontinued in the late spring of 1940.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Balkans Campaign was a bit of a sideshow for the German military. Only LAH and the SS-V Division, now retitled SS-Division Reich, participated. LAH followed the Panzer advance through Serbia before going into action to force open the passes of northern Greece. Once in southern Greece, elements of LAH made a surprise crossing of the Gulf of Corinth, which outflanked Allied defenses in the Peloponnese.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reich passed through the Serbian portion of the Banat, as part of the German operation to capture Belgrade. The city surrendered to a reconnaissance patrol from the division. This was a propaganda coup for the Waffen-SS, as German Army units had been in more favorable positions to take the Yugoslav capital.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preparations for the planned invasion of the Soviet Union continued during the fighting in Greece and Yugoslavia. The Waffen-SS assembled a new motorized division by merging the Germania Regiment (detached from Reich) with newly-formed infantry regiments created to include Scandinavian and Dutch-Flemish volunteers, titled Nordland and Westland. Together they became the Wiking Division, which was supposed to attain the same elite status as LAH and Reich. SS infantry regiments, retitled from the Totenkopf regiments, continued occupation duties.The exception was SS-Infantry Regiment 11, which had joined Reich as the replacement for Germania.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_15_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Fritz Klingenberg led an advance patrol of ten men from his 1st Company of Motorcycle Battalion Reich into Belgrade on April 12, 1941. He met German diplomats by chance, and was brought to the German Consulate. The mayor of the city came to the consulate for a discussion. Klingenberg bluffed that he had many more men with him, a short distance away.The mayor took the bait, and surrendered the city to Klingenberg.This feat brought Klingenberg the Knight’s Cross on April 14.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_16_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Klingenberg received his Knight’s Cross soon after, in a personal audience with Adolf Hitler.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_17_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Fritz Witt was transferred to LAH prior to the Balkans Campaign. He commanded the 1st Battalion, with Gerd Pleiss commanding its 1st Company. On April 12, the same day Klingenberg captured Belgrade, Pleiss led the decisive attack that enabled the Germans to capture the Klidi Pass in northern Greece. For this, Pleiss was awarded the Knight’s Cross a week later on April 20. Pleiss was a tall man, and his company contained the tallest men in the LAH, each at least 190cm in height. Pleiss is seen here on home leave, prior to the start of the campaign in the Soviet Union.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_18_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Kurt Meyer commanded the LAH Reconnaissance Battalion during the Balkans Campaign, and won the Knight’s Cross on May 18, 1941. His unit had broken Greek resistance around Klissura Pass, and captured many prisoners.This photo was taken a few months later, during LAH’s advance through the southern Soviet Union.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-19"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Germany invaded the Soviet Union on June 22, 1941 in Operation BARBAROSSA. For the offensive, the Waffen-SS contributed LAH, Reich, Totenkopf, SS-Polizei, Wiking and units formed from former Totenkopf regiments. These included three regiments in Finland (two of them forming SS-Battle Group Nord, later expanded into a mountain division), a brigade of cavalry and two infantry brigades.These cavalry and infantry brigades were formed to assist the Action Groups in murdering civilians and stragglers, but after serving in this role during the summer, gradually took on combat duties due to the crises of the fall and winter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("LAH and Wiking fought with Army Group South during this campaign. Reich was with Army Group Center.Army Group North included Totenkopf and SS-Polizei. All saw extremely heavy fighting and took serious casualties. The summer and fall were times of advances, sometimes mixed with defensive stands. The winter featured successful defensive fighting against Soviet counteroffensives.The Waffen-SS units were depleted, so that LAH and Reich were withdrawn to rebuild, followed eventually by Totenkopf. SS-Polizei and Wiking remained at the front all through 1942, with the former continuing to fight defensive battles and the latter advancing to the Caucasus. By the end of 1942, the German Eastern Front was facing a new round of crises. LAH, Reich (now with its title modified to Das Reich) and Totenkopf were joined into the SS-Panzerkorps. Battle Group Nord and the SS-Cavalry Brigade had transformed into full divisions, and a division of ethnic German conscripts was preparing to enter combat in occupied Yugoslavia as SS-Volunteer Mountain Division Prinz Eugen. The forming of new SS armored divisions was in the planning stage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From this point onward, it is no longer possible to offer comprehensive coverage of Waffen-SS Knight’s Cross winners. The photos will focus on images with many medals visible, and on ones portraying leading personalities.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_19_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Theodor Wisch commanded the 2nd Battalion of LAH during BARBAROSSA. During the second week of July, he and his men defended the main supply routes of Army Group South. For this, Wisch was awarded the Knight’s Cross on September 15, 1941. Soon after, he posed with the other LAH Knight’s Cross winners. From the left are Gerd Pleiss (died of wounds on November 17, 1941), Wisch, Sepp Dietrich, Fritz Witt and Kurt Meyer.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_20_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Paul Hausser was the first commander of the Reich Division and later of the SS-Panzerkorps. His distinguished leadership of Reich in the Western Campaign and then during the advance to Yelna, in Russia, was recognized through his August 8, 1941 award of the Knight’s Cross. Hausser wears the early style of Gruppenführer collar patches in this photo taken soon after he received his Knight’s Cross.Two months later, on October 14, Hausser was wounded by shrapnel in his face, losing his right eye. For the rest of the war, he was usually photographed from the left side.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_20_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Totenkopf Division commander Theodor Eicke in the summer or autumn of 1942. He won the Knight’s Cross on December 26, 1941 for his division’s leading role in containing Soviet counterattacks during Army Group North’s advance towards Leningrad and Novgorod.These were considered incredibly difficult and costly battles, but Totenkopf experienced far worse in early 1942 at Staraya Russa and then at Demyansk. For these, Eicke was awarded the Oak Leaves on April 20, 1942, with his promotion to Obergruppenführer dated the same day. In this image, Eicke also wears his Wound Badge in Silver and Gold Nazi Party Badge. Nazi Party members in the Wehrmacht and Waffen-SS had their memberships suspended for the duration of the war, since soldiers were not supposed to be political. However, Waffen-SS members sometimes wore their Nazi Party badges for propaganda photos such as this one, which would be distributed to the press.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_21_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Seen in the spring of 1942 is SS-Polizei Division commander Alfred Wünnenberg. His Knight’s Cross was won on November 15, 1941 as a regimental commander in the same division. The SS-Polizei was not motorized at this time, but had fought with distinction as an assault division in the advance on Leningrad. Wünnenberg wears Clasps to both of his Iron Crosses won in the First World War. Also from that conflict, he displays the Wound Badge in Silver and the Bavarian Observer’s Badge for Pilots. Next to the latter are SS runes showing SS membership while wearing a police general’s tunic. Unusually, the tunic has a Heer eagle on the left sleeve instead of the typical SS pattern. Wünnenberg won the Oak Leaves on April 23, 1942 after his division played a leading role in containing the Soviet Volkhov Pocket.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_22_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Wünnenberg wears an SS tunic and his Oak Leaves in this early October 1942 portrait. SS-Polizei held an awards ceremony that day, honoring two Knight’s Cross winners and two German Cross in Gold winners. From the left are Günther Butte (German Cross in Gold September 11, 1942), Karl Schümers (German Cross in Gold August 3, 1942, Knight’s Cross September 30, 1942), Wünnenberg, Otto Gieseke (German Cross in Gold September 12, 1942, Knight’s Cross September 30, 1942), and Hans Traupe (German Cross in Gold September 25, 1942). These newly-decorated officers had distinguished themselves in the fighting for the Volkhov Pocket and during the First Battle of Lake Ladoga. Traupe later won the Knight’s Cross on February 23, 1944 for his battalion’s role in covering the German retreat from the Volkhov River to the Panther Line defenses the previous month.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_23_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Rudolf Seitz was an experienced gun commander in the SS-Polizei Anti-Tank Battalion. He was awarded the Knight’s Cross on October 21, 1942, probably for actions during the First Battle of Lake Ladoga. Seitz’s veteran status is shown by his Wound Badge in Silver and General Assault Badge (awarded to personnel who were not in the infantry or armor branches of service). He also has the ribbon for the Eastern Front Medal under the ribbon for his Iron Cross Second Class.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_23_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("August Zingel distinguished himself leading raids and reconnaissance missions in the Demyansk cauldron. A successful operation on September 10, 1942 was the catalyst for his award of the Knight’s Cross a few weeks later on October 4. Zingel’s dress uniform includes an Honor Stripe on his right sleeve for his early Hitler Youth membership, and the Infantry Assault Badge next to his Iron Cross First Class.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_24_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Seitz and Zingel posed together for this photo, taken during 1943. Both became officers the next year. Zingel wears the Death’s Head cuff title unofficially used by Totenkopf Infanterie Regiment 1 (later known as SS-Panzergrenadier Regiment 5 Totenkopf), and has his regiment’s “1” on his shoulder boards.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_25_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Karl Ullrich took command of Totenkopf’s Combat Engineer Battalion just before BARBAROSSA. In early 1942, he led a battle group based around his battalion. It held a key strongpoint near Staraya Russa for several weeks against intense Soviet attacks, for which Ullrich won the Knight’s Cross on February 14, 1942.The scar on his chin was not obtained in combat, but was actually from a pre-war injury.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_25_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Ludwig Köchle led many raids and counterattacks during Totenkopf’s early 1942 defensive fighting around Staraya Russa.This brought him the Knight’s Cross on February 28, 1942. Köchle was featured in many press photos such as this one, but was only able to enjoy his award for three months. He was killed by Soviet artillery fire on June 9, in the Demyansk cauldron.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_26_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An important part of Totenkopf’s early defensive success at Demyansk was the support provided by its assault gun battery. For this, the battery’s acting commander, Erwin Meierdress, was awarded the Knight’s Cross on March 13, 1942. He received the award while hospitalized and other photos from this sequence show that he was wearing pajama pants while posing.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_27_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Another Totenkopf hero from this era was Hans Hirning, who won his Knight’s Cross on October 23, 1942. He had been part of the veteran cadre that enabled the division to keep fighting at Demyansk, with mostly replacements in the ranks. Along with his Iron Cross First Class, Infantry Assault Badge and Wound Badge in Black, Hirning has on his right sleeve the Tank Destruction Badge for single-handedly destroying an enemy tank or armored vehicle.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_28_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Helmut Pförtner was considered one of the bravest officers in Wiking during the summer of 1941. His actions brought him both the German Cross in Gold and the Knight’s Cross on November 22, 1941. He was hospitalized due to wounds on that date, and in this spring 1942 photo he wears the Wound Badge in Silver next to his Infantry Assault Badge in Silver.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_29_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Pförtner’s battalion commander was August Dieckmann, who led Germania’s 1st Battalion in defensive fighting detached from Wiking in early 1942. German Army commanders recommended him for the Knight’s Cross, which was awarded on April 23, 1942.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_30_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("The guns of Karl Schlamelcher’s 3rd Battalion of the Wiking Artillery Regiment provided outstanding support during the Mius River fighting in early 1942.This brought him the Knight’s Cross on March 1 of that year. Schlamelcher was badly wounded that summer, during the advance to the Caucasus.This earned him the Wound Badge in Silver that he wears in this photo. No longer fit for front-line service, Schlamelcher excelled in commanding artillery instructional units for the rest of the war. He never fully recovered from his injuries, and died in 1948 at the age of 35.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_30_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Bernhard Griese and Rudolf Pannier pose together during a meeting with Heinrich Himmler, circa late May 1942. Though not obvious from this photo, the men were the same age, both born in 1897. Both were First World War veterans, who then served in the paramilitary Freikorps before making careers in the Order Police. Griese won the Knight’s Cross on May 3, 1942 for leading Police Battalion 323 in defensive fighting west of Moscow in the preceding months. He wears the Clasp to his First World War Iron Cross Second Class on the ribbon to the earlier award, along with the Second World War Iron Cross First Class. Pannier won the Knight’s Cross on May 11, 1942 for commanding the 1st Battalion of Police Infantry Regiment 2 in the SS-Polizei Division in holding the key strongpoint of Ljubino Pole during the early stages of the Volkhov Pocket fighting.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_31_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("SS-Infantry Regiment 4 was nearly destroyed in the defensive fighting west of Moscow in early 1942. Its sacrifice brought it the honor title Langemarck, with Commander Hinrich Schuldt winning the Knight’s Cross on April 5, 1942. Schuldt, nicknamed “Kapitän” from his earlier service as a naval officer, is seen a few months later, posing with his 1st Battalion commander, Jakob ‘Jopp’ Fick.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-32"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_32_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The countries allied with Germany occasionally bestowed decorations on Waffen-SS men who fought near their territory or with their soldiers. LAH rested and reorganized during the summer and autumn of 1942, and Fritz Witt posed at this time to display his new, foreign acquisitions. Under his Knight’s Cross is the Romanian Order of the Star, while the Bulgarian Military Order for Bravery in War is below his Iron Cross First Class. Witt also wears the German Cross in Gold he won on February 8 1942.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-33"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The SS-Panzerkorps, with LAH, Das Reich and Totenkopf, returned to combat in January 1943. After LAH and Das Reich defended near Kharkov and eventually abandoned the city, they were joined by Totenkopf in a successful counteroffensive. Kharkov was recaptured, and the Soviet winter offensive that had started around Stalingrad was ended.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the same time, Wiking retreated from the Caucasus before helping contain the Soviet winter offensive to the south of Kharkov. SS-Polizei and the 2nd SS-Infantry Brigade (now an international unit, including Germanic and Baltic volunteers) fought near Leningrad in the Second Battle of Lake Ladoga. The foreign volunteers then spent the summer of 1943 reorganizing into independent brigades and divisions of Dutch, Flemish, Walloons, Scandinavians, Estonians and Latvians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The SS-Panzerkorps had a lead role in the early July 1943 Kursk offensive. LAH was then sent to Italy to prop up the Fascist government. Das Reich and Totenkopf joined German Army units in destroying the Soviet Mius River bridgehead at the end of July and beginning of August. They then returned to the Kharkov area, with the city being lost for good in late summer. As this went on, Wiking contained a major Soviet offensive near Izyum, before joining Das Reich and Totenkopf in the unsuccessful defense of the Kharkov area. All three divisions then helped cover the German retreat to the Dnieper River.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Soviets advanced across the Dnieper at several points and recaptured Kiev on November 6. LAH returned to Ukraine during October, where it was nearly destroyed over the following six months. Totenkopf was also reduced to remnants as it gradually retreated from southern Ukraine to eastern Romania.The majority of Das Reich was withdrawn in early December, 1943 for rebuilding.The battlegroup it left behind fought in Ukraine until the spring, when the last depleted elements rejoined the main body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wiking was surrounded in the Cherkassy Pocket in early 1944, along with the attached Walloon Assault Brigade and German Army units. The encircled troops broke out during February, with heavy casualties and the loss of most equipment. Wiking then refitted, while elements fought near Kovel. Totenkopf rebuilt in Romania. LAH refitted in Flanders, near its newly-formed sister division, Hitlerjugend. Das Reich rebuilt in France, near the newly-formed Götz von Berlichingen Division.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The new Hohenstaufen and Frundsberg Divisions formed in France and Belgium at the same time, but were committed to combat ahead of the other new divisions. During March 1944, grouped as the 2nd SS-Panzerkorps, they were sent to western Ukraine to relieve the German troops, including elements of LAH and the Das Reich battlegroup, caught in the Hube Pocket. After this successful operation, Hohenstaufen and Frundsberg were kept at readiness for a return to France for their originally-intended role, combating the Allied invasion expected in the summer of 1944.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-34"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_34_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gerardus Mooyman was the gunner of an anti-tank gun in the Anti-Tank Company of the Legion Nederland. He knocked out numerous Soviet tanks during the Second Battle of Lake Ladoga, for which he won the Knight’s Cross on February 20, 1943. Mooyman’s achievement was honored at a banquet, where he sat by 2nd SS-Infantry Brigade commander Fritz von Scholz.The latter had won his Knight’s Cross on January 18, 1942 as commander of the Nordland Regiment in Wiking. Soon after this photo was taken, he began forming the Nordland Division, which had his old regiment as cadre.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_34_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Hinrich Schuldt in the late summer of 1943, as commander of the 2nd SS-Infantry Brigade, which was now a Latvian unit. Schuldt had won the Oak Leaves on April 2 of that year, after commanding a mixed battlegroup for emergency service on the Don River front during the Stalingrad crisis.Three weeks later, on April 21, he won the German Cross in Gold for unspecified actions in the preceding years. Schuldt has also added the Wound Badge in Silver after being seriously wounded during the Don fighting.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_35_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Another early 1943 Oak Leaves winner was Fritz Witt. His award was dated March 1, and reflected 1941 combats in Greece and the Soviet Union and early 1943 defensive fighting near Kharkov. Witt soon left LAH, to begin forming its intended sister division, Hitlerjugend.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_36_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Also assigned to the cadre of Hitlerjugend was Kurt Meyer, who led one of its infantry regiments. He too won the Oak Leaves during the Kharkov campaign on February 23 in recognition of successful actions in 1941 and early 1943. Despite the serious situation at the front, he was flown to Hitler’s headquarters to receive the award personally, as shown in this photo.Two days later, Meyer was back with his LAH Reconnaissance Battalion in Ukraine. It was only learned many years after the war that during the February fighting, Meyer had his men destroy two Ukrainian villages and kill hundreds of civilians in retaliation for alleged partisan activity.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-37"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_37_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Meyer poses in the late spring of 1943 with Max Wünsche, commander of the 1st Battalion of SSPanzer Regiment 1. Wünsche won the Knight’s Cross on February 28, 1943, three days after he had been awarded the German Cross in Gold. His battalion had frequently fought alongside Meyer’s during the defensive fighting near Kharkov, prior to the German counter-offensive. Wünsche also became part of the Hitlerjugend cadre, serving as the first commander of the division’s Panzer Regiment.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-38"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_38_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Meyer was known for recommending his subordinates for decorations. Here he places the ribbon of the Knight’s Cross under the collar of Hermann Weiser, his 2nd Company commander. Weiser’s award was dated March 28, 1943 and reflected his leading role in the recapture of Valki that month, as well as how his company held out successfully while surrounded during the recapture of Kharkov. LAH divisional Surgeon Dr Hermann Besuden watches on the right.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-39"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_39_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Sepp Dietrich’s 51st birthday on May 28, 1943 was celebrated with a big banquet in Kharkov, which was attended by many Waffen-SS senior officers. A less formal photo from this occasion finds Kurt Meyer sharing a toast with Wilhelm Mohnke, commander of LAH Replacement Battalion.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_40_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Another photo from the same event. Dietrich poses with Teddy Wisch behind him. Flanking them are recent Knight’s Cross winners Hugo Kraas, left (March 23, 1943 as commander of the 1st Battalion, SS-Panzergrenadier Regiment 2), and Albert Frey (March 3, 1943 as commander of the 1st Battalion, SS-Panzergrenadier Regiment 1). For this occasion, Dietrich wears the ribbon of the Blood Order on his right pocket flap and his Gold Nazi Party Badge on the left flap. Instead of his First World War Iron Cross 1st Class with Second World War Clasp, he has on his left pocket his First World War Tank Battle Badge, and his honorary Luftwaffe Combined Pilot-Observer’s Badge in Gold.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-41"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_41_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Rudolf Sandig distinguished himself on several occasions during the Kharkov campaign while commanding the 2nd Battalion of SS-Panzergrenadier Regiment 2.This led to his Knight’s Cross, dated May 5, 1943. Sandig had won one of the first German Crosses in Gold awarded in the German military on December 26, 1941. As with other LAH officers, just visible below his Iron Cross First Class, he has the Bulgarian Military Order for Bravery in War.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-42"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_42_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("LAH armored half-track battalion, under the command of Joachim Peiper, led the division’s advance into Kharkov.Twice it captured bridgeheads which acted as the springboard for other divisional elements to carry the offensive forward. For this, and for the earlier rescue of the trapped 320th Infantry Division, Peiper won the Knight’s Cross on March 12, 1943. At the same time, his platoon commanders Werner Wolff and Paul Guhl were awarded the Iron Cross First Class.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-43"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_43_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("During the recapture of Kharkov, Walter Gerth’s 7th Battery of SS-Artillery Regiment 3 found itself blocking the retreat route of surrounded Soviet forces. Gerth led his men in heavy combat, which sometimes became hand-to-hand. Their successful stand allowed other elements of Totenkopf to destroy the surrounded Red Army units. Gerth was awarded the Knight’s Cross on March 31, 1943. In this photo, he wears the Wound Badge in Gold beneath his binoculars.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-44"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_44_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Joachim Schubach, the commander of the 3rd Battalion of SS-Panzergrenadier Regiment 5, won his Knight’s Cross in circumstances similar to Gerth’s. Schubach’s command blocked the way of Soviet forces retreating from Kharkov to the south-east, so that they too could be destroyed. Schubach was badly wounded in the fighting on March 17, 1943, and was recommended for the Knight’s Cross the same day.The award was approved on April 3.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-45"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_45_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Totenkopf was hard-pressed to hold the villages it had captured during the retaking of Kharkov. It successfully fought off numerous Soviet counterattacks, and Waldemar Riefkogel distinguished himself in one of these engagements. On March 17, 1943 he led two tanks of his 1st Company of SS-Panzer Regiment 3 in supporting the infantry holding the village of Tschugujev. After knocking out several Soviet tanks, Riefkogel dismounted and led the infantry in an attack that routed their opponent. He was recommended for the Knight’s Cross soon after, but the award was not approved until July 11, 1943 during the Kursk offensive.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_45_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Also awarded the Knight’s Cross on April 3, 1943 was Arzelino ‘Lino’ Masarie, acting commander of Totenkopf’s Reconnaissance Battalion. During the drive to retake Kharkov, he had captured and held an important village on his own initiative.This had kept the offensive moving forward and resulted in extensive booty. Masarie was one of a number of SS men with Italian ancestry who won the Knight’s Cross.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-46"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_46_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Das Reich held an award ceremony during April 1943 for men who had won the Knight’s Cross or German Cross in Gold. New division commander Walter Krüger is placing the ribbon of the Knight’s Cross around the neck of Hans Weiss.Vinzenz Kaiser stands next to Weiss, with four Tank Destruction Badges on his right sleeve. Behind Kaiser, divisional Adjutant Dieter Kesten is adjusting the Knight’s Cross ribbon under the collar of Sylvester Stadler. Finally, Karl Heinz Worthmann is next to Stadler, in black Panzer uniform.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-47"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_47_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Karl Heinz Worthmann was a career NCO with Germania, as reflected by his Infantry Assault Badge. His Silver Wound Badge was due to being severely wounded during Barbarossa. Upon recovery, Worthmann became a platoon commander in the 6th Company of SS-Panzer Regiment 2. He led numerous decisive counterattacks during the defensive fighting near Kharkov in early February 1943. On February 20, Worthmann was both promoted to junior officer for bravery, and recommended for the Knight’s Cross.The award was approved on March 31.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-48"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_48_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Sylvester Stadler owed his unusual first name to having been born on December 30, the time known as the Sylvester New Year’s holiday in Central Europe. As commander of the 2nd Battalion of Der Führer, his Knight’s Cross was approved on April 6, 1943 for leading an important night attack during the advance to recapture Kharkov.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-49"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_49_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Also approved on April 6 was the Knight’s Cross for Vinzenz Kaiser. He had taken acting command of the 3rd Battalion of Der Führer during the Kharkov campaign. He led a decisive attack on his own initiative during the recapture of Kharkov, and personally destroyed four Soviet tanks. This is shown by the four Tank Destruction Badges on his right sleeve. Kaiser wears the Gold Nazi Party Badge above his Iron Cross First Class. As mentioned before, soldiers were supposed to be apolitical, so Waffen-SS men who were Nazi Party members had their memberships suspended for the duration of the war. However, individuals such as Kaiser still wore their Party badges for official portraits to show their affiliation.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_50_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Hans Weiss was acting commander of Das Reich’s Reconnaissance Battalion during the Kharkov counteroffensive. He was another April 6 Knight’s Cross winner for personally leading the advance element of his battalion in several crucial actions during the drive toward Kharkov, and then in the city. During 1943, Weiss transferred to command of the 1st Battalion of SS-Panzer Regiment 2. This 1944 photo shows him in Panzer uniform, with the German Cross in Gold he won on April 23 of that year. Weiss also wears the Wound Badge in Silver and the Close Combat Clasp in Silver, an award not listed among his decorations received.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-51"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_51_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Also at Das Reich’s awards ceremony were Otto Kumm and Christian Tychsen, the latter overcome with emotion. Kumm received the certificate for the Oak Leaves to his Knight’s Cross. Tychsen was awarded the Knight’s Cross on March 31, 1943 as the commander of the 2nd Battalion of SS-Panzer Regiment 2. He had led attacks the previous month which relieved pressure on Das Reich, enabling the division to extricate itself from Kharkov and retreat successfully prior to the counteroffensive that recaptured the city.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-52"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_52_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Der Führer commander Otto Kumm was the first Oak Leaves winner in Das Reich, with his award approved on April 6. He had always been up front at the most important point of his regiment’s commitment area, as it parried Soviet attacks and launched counterattacks.This had delayed the Soviet advance on Kharkov during early February 1943. Kumm received his Oak Leaves personally from Adolf Hitler at the latter’s headquarters on May 20, 1943.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-53"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_53_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Not part of the assembled award winners was Hans Macher, commander of Deutschland’s Combat Engineer Company. He was on a propaganda tour in Germany with other veterans of the victorious Kharkov campaign and received his Knight’s Cross there. It was approved on April 3, for the way he and his company led Deutschland’s advance into Kharkov during the recapture of the city. As a Combat Engineer, Macher wears the General Assault Badge next to his Wound Badge in Silver. His Tank Destruction Badge was for a Soviet tank he destroyed on February 24, 1943.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-54"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_54_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Karl Kloskowski was an NCO platoon commander in the 4th Company of SS-Panzer Regiment 2. He led the Das Reich advance on Pavlograd on February 21, 1943. His point platoon captured an important bridge, which made the conquest of the city possible, and for this he won a delayed award of the Knight’s Cross on July 11, 1943. He was also promoted to officer rank.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-55"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_55_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("On July 8, 1943, during the Kursk offensive, as LAH advanced to the north, Franz Staudegger remained in the rear at a maintenance facility with his broken-down Tiger tank. Nearby infantry warned Staudegger that a surprise mass Soviet tank attack was forming to assault their position, and thus strike the flank of the SS-Panzerkorps advance to the north. Staudegger made his Tiger provisionally mobile and moved it to an ambush position. He then defeated the Soviet attack by knocking out twenty-two of their tanks. Staudegger was awarded the Knight’s Cross on July 10, and soon after was flown to Hitler’s headquarters to report on conditions at the front.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-56"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_56_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("The most famous part of the Battle of Kursk was the 5th Guards Tank Army’s attack against LAH on July 12, near Prochorovka. It struck the positions of the battlegroup formed from the half-track battalion and the 2nd Battalion of the Panzer Regiment. A major role in defeating the onslaught was played by the 6th Company of the latter, under the acting command of Rudolf von Ribbentrop, the son of German Foreign Minister Joachim von Ribbentrop. Rudolf von Ribbentrop was awarded the Knight’s Cross three days later. He was the last surviving Waffen-SS Knight’s Cross winner, until he died on May 20, 2019.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_56_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Von Ribbentrop’s battalion commander, Martin Gross, won the Knight’s Cross on July 22 for the same fighting. He had been awarded the German Cross in Gold following the Kharkov campaign.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-57"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_57_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Werner Wolff was the adjutant of LAH half-track battalion during Kursk. On July 12, in the Prochorovka fighting, he took acting command of one of his battalion’s companies after its commander was wounded. Wolff led the men in destroying many Soviet tanks in close combat. He poses here with the Knight’s Cross he was awarded on August 7, 1943 and a Tank Destruction Badge under his adjutant’s cords. Wolff also wears the Iron Cross First Class, the Infantry Assault Badge in Bronze, the Wound Badge in Black and the Close Combat Clasp in Bronze.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-58"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_58_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The lightly-armored Marder tank-destroyers of SS-Panzerjäger Battalion LAH also helped defeat the Soviet attacks on July 12. For this, platoon commander Kurt Sametreiter was awarded the Knight’s Cross on July 31. This photo shows him later, after he was promoted to officer rank and transferred to the Panzer Regiment. Sametreiter has LAH ciphers on his shoulder boards, and the Panzer Assault Badge in Silver next to his Iron Cross First Class.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-59"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_59_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Wiking was in reserve during Kursk. On July 17, it was rushed to the Izyum area, where the Soviets had formed a bridgehead across the Donets River. Over the next four days, the division helped contain repeated Soviet efforts to break out of the bridgehead and cut the main German supply railroad line. Germania commander Jürgen Wagner was awarded the Knight’s Cross on July 24 because he was always at the focal point as his regiment helped master the crises of the preceding days.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_59_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Albert Müller commanded the anti-tank gun platoon in the 4th Company of Westland. His guns were crucial in helping his battalion hold on to the town of Ssredni, and Müller probably took acting command of his company when the commander was killed in the fighting. Müller was awarded the Knight’s Cross on August 4. For this portrait, he wears the uncommon Infantry Assault Badge in Bronze, which he received before Wiking’s infantry were reclassified from motorized infantry to Panzergrenadiers.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_60_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Also awarded the Knight’s Cross on August 4 was Walter Schmidt, commander of Westland’s 2nd Battalion. While his battalion held Savodskoje, next to Ssredni, in desperate combat, he led a small group of men across the Donets into the Soviet rear. Their surprise attack eased the pressure against the main body of his battalion.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-61"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_61_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Günther Sitter was awarded his Knight’s Cross a bit later on September 12 for the same fighting. He commanded Westland’s 1st Battalion, and thus was Albert Müller’s battalion commander. He led the successful defense of Ssredni, to which Müller had made an important contribution. Other photos from this sequence suggest Wiking commander Herbert Otto Gille used his own Knight’s Cross as a presentation piece for Sitter.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-62"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_62_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("On the right is Günther-Eberhard Wisliceny, commander of the 3rd Battalion of Regiment Deutschland, posing with his 10th Company commander Helmuth Schreiber. Both men were awarded the Knight’s Cross on July 30, 1943 for their leadership in the early phases of the Kursk offensive. Wisliceny wears enlisted-grade collar patches with his officer rank pips, while Schreiber has the normal officer-grade collar patches with laced borders.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-63"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_63_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A Das Reich command conference in the late summer of 1943. Division commander Walter Krüger is at center, surrounded by his regimental commanders. From the left are SS-Panzer Regiment 2 commander Hans-Albin Freiherr von Reitzenstein, Deutschland commander Heinz Harmel, Krüger, an orderly officer, and Der Führer commander Sylvester Stadler.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-64"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_64_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Heinz Harmel in the spring of 1944, with the decorations he mostly earned during 1943. He won the Oak Leaves on September 7, 1943 and the Close Combat Clasp in Silver three days later.The Oak Leaves were for Regiment Deutschland’s role in the destruction of the Soviet bridgehead on the west bank of the Mius River. Harmel had won one of the first German Crosses in Gold in late 1941, and was awarded his Tank Destruction Badge on the same day as his Knight’s Cross, March 31, 1943.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_64_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("On September 26, 1943, Sylvester Stadler and Walter Krüger flew to Hitler’s headquarters to receive the Oak Leaves to their Knight’s Crosses. Krüger and Heinrich Himmler observe, as Stadler shakes Hitler’s hand. During defensive fighting near Kharkov, Stadler had arrived at a threatened sector ahead of his regiment. With only a handful of men, he held up a Soviet attack while personally manning a machine gun.This brought him the Oak Leaves, awarded on September 16.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-65"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_65_001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Krüger’s Oak Leaves were awarded on August 31.They recognized Das Reich’s success at Kursk and the Mius bridgehead. On his left breast pocket, Krüger wears the Baltic Cross he earned fighting with the Freikorps in the Baltic States following the First World War.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Img_65_002.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionl"
  }, [_vm._v("Josef ‘Sepp’ Lainer, a platoon commander in the 3rd Company of Der Führer, was awarded the Knight’s Cross on October 8, 1943. It was in recognition of his role in the same defensive fighting that had commenced with his regimental commander Stadler’s personal action.The medal was presented some time later, along with two decorations awarded on October 15, the Wound Badge in Gold and Close Combat Clasp in Gold.The latter was one of the first to be earned in the German military. In this photo, Lainer also wears the Infantry Assault Badge in Bronze.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b70da7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/005_Chapter_1.vue
// module id = 69
// module chunks = 0